import React from 'react';
import { motion } from 'framer-motion';
import { Download, CalendarClock, Sparkles } from 'lucide-react';
const steps = [{
  icon: Download,
  title: 'Descarga el Manual',
  desc: 'Recibe el PDF en tu correo de inmediato tras la compra.'
}, {
  icon: CalendarClock,
  title: 'Sigue el Cronograma',
  desc: "Aplica el protocolo de la 'Tríada Enzimática' durante 24 horas."
}, {
  icon: Sparkles,
  title: 'Mira el Espejo',
  desc: 'Despierta al día siguiente con el abdomen plano y una ligereza que no sentías hace meses.'
}];
export function HowItWorks() {
  return <section className="py-16 md:py-24 px-4 bg-cream-dark" data-id="element-77">
      <div className="max-w-5xl mx-auto" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-79">
          <h2 className="text-3xl md:text-4xl font-bold text-forest mb-4" data-id="element-80">
            ¿Cómo funciona?
          </h2>
          <div className="w-24 h-1 bg-orange mx-auto rounded-full" data-id="element-81"></div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-82">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-forest-100 -z-0" data-id="element-83"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-84">
              <div className="w-24 h-24 bg-white rounded-full shadow-lg flex items-center justify-center mb-6 border-4 border-cream-dark relative" data-id="element-85">
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-orange text-white rounded-full flex items-center justify-center font-bold shadow-md" data-id="element-86">
                  {index + 1}
                </div>
                <step.icon className="w-10 h-10 text-forest" data-id="element-87" />
              </div>
              <h3 className="text-xl font-bold text-charcoal mb-3" data-id="element-88">
                {step.title}
              </h3>
              <p className="text-charcoal-light" data-id="element-89">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}